<div class="row pt-4">
    <div class="col-md-5">
        <div class="card p-3 mb-4">
            <form role="form" [formGroup]="formCadastroBlacklists"
                (ngSubmit)="envioLoginBlacklist()">
                <h5 class="mb-0">Cadastro/edição da Blacklist</h5> <hr>
                <div class="form-group">
                    <strong for="exampleInputLogin">Login *</strong>
                    <input type="text" class="form-control" formControlName="login" placeholder="Digite o login que deseja bloquear">
                </div>
                <button type="submit" class="btn btn-success btn-custom">Salvar</button>
            </form>
        </div>
    </div>
    <div class="col-md-7">
        <div class="card p-3">
            <div class="d-flex flex-row align-items-center">
                <h5 class="mb-0 mr-auto">Logins bloqueados</h5> 
                <div class="justify-items-end">
                    <button class="btn mr-2 btn-light ml-auto" (click)="baixarTemplate()" pTooltip="Baixar modelo de importação">
                        <i class="fas fa-file-download"></i>
                    </button>
                    <button class="btn btn-success ml-auto" data-toggle="modal" data-target="#modalblacklistcsv" pTooltip="Importar candidatos">
                        <i class="fas fa-file-csv"></i>
                    </button>
                </div>
            </div>
            <hr>
            <table class="table table-bordered">
                <thead>
                    <tr>
                        <th style="width: 70%;">Login</th>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let c of listaBlacklist">
                        <td>{{c.login}}</td>
                        <td class="text-center">
                            <button class="btn p-1 act" data-toggle="tooltip" title="excluir" (click)="excluirDaBlacklist(c.id)">
                                <i class="fas fa-trash fa-xs"></i>
                            </button>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
 <!-- The Modal -->
 <div class="modal fade" id="modalblacklistcsv"  #content>
   <cadastro-massa-blacklist></cadastro-massa-blacklist> 
 </div>


</div>